import { Injectable, signal } from '@angular/core';

export type AppTheme = 'light' | 'dark';

const THEME_STORAGE_KEY = 'phd-compass-theme';
const DEFAULT_THEME: AppTheme = 'light';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  readonly currentTheme = signal<AppTheme>(this.loadInitialTheme());

  constructor() {
    this.applyTheme(this.currentTheme());
  }

  toggleTheme(): void {
    this.setTheme(this.currentTheme() === 'dark' ? 'light' : 'dark');
  }

  setTheme(theme: AppTheme): void {
    if (!this.isSupportedTheme(theme)) return;

    this.currentTheme.set(theme);
    localStorage.setItem(THEME_STORAGE_KEY, theme);
    this.applyTheme(theme);
  }

  private applyTheme(theme: AppTheme): void {
    document.documentElement.dataset['theme'] = theme;
    document.documentElement.setAttribute('data-bs-theme', theme);
  }

  private loadInitialTheme(): AppTheme {
    const savedTheme = localStorage.getItem(THEME_STORAGE_KEY);
    return this.isSupportedTheme(savedTheme) ? savedTheme : DEFAULT_THEME;
  }

  private isSupportedTheme(theme: string | null): theme is AppTheme {
    return theme === 'light' || theme === 'dark';
  }
}